import { useActivityFormStore } from "../activity_form_store";
import { useSubtemplate } from "./use_subtemplate";

export const useIsSubtemplatesLogicActive = () => {
  const { isEdit, isClone } = useActivityFormStore((state) => state.activityStatus);
  const subtemplates = useActivityFormStore((state) => state.subtemplates);
  const subtemplate = useSubtemplate();

  const hasSubtemplates = subtemplates.length > 0;

  if (!hasSubtemplates) {
    return false;
  }

  return !((isEdit || isClone) && !subtemplate);
};
